import { useEffect } from "react";

const GA_ID = "G-MY8YB3DJMN";
const CONSENT_KEY = "cookie_consent";

export const getConsentValue = () => localStorage.getItem(CONSENT_KEY);

function loadGA() {
  if (document.getElementById("ga-script")) return;

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    (window as any).dataLayer.push(arguments);
  };
  (window as any).gtag("js", new Date());
  (window as any).gtag("config", GA_ID);

  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export const useGoogleAnalytics = () => {
  useEffect(() => {
    if (getConsentValue() === "accepted") {
      loadGA();
    }

    const handler = () => loadGA();
    window.addEventListener("cookie_consent_accepted", handler);
    return () => window.removeEventListener("cookie_consent_accepted", handler);
  }, []);
};
